// services/statistic-data/response/StatisticOverviewResponse.ts

import { z } from "zod";

// Skema untuk objek 'data'
const StatisticOverviewDataSchema = z.object({
    total_booking: z.number(),
    total_booking_sub_month: z.number(),
    total_booking_sub_year: z.number(),
    total_revenue: z.coerce.number(),
    total_revenue_sub_month: z.coerce.number(),
    total_revenue_sub_year: z.coerce.number(),
});

// Skema untuk keseluruhan respons API
const StatisticOverviewResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: StatisticOverviewDataSchema,
});

// Ekspor tipe data yang di-infer dari skema untuk digunakan di seluruh aplikasi
type StatisticOverviewResponse = z.infer<typeof StatisticOverviewResponseSchema>;
type StatisticOverviewData = z.infer<typeof StatisticOverviewDataSchema>;

export { StatisticOverviewResponseSchema };
export type { StatisticOverviewResponse, StatisticOverviewData };